import React from "react";
import img1 from "./images/firebase.png";
import img2 from "./images/js.png";
import img3 from "./images/js2.png";
import img4 from "./images/json.png";
import img5 from "./images/laravel.png";
import img6 from "./images/mongodb.png";
import img7 from "./images/mysql.png";
import img8 from "./images/node.png";
import img9 from "./images/php.png";
import img10 from "./images/react.png";
import img11 from "./images/schema.png";
import img12 from "./images/java.png";
import img13 from "./images/git.png";
import img14 from "./images/npm.png";
import img15 from "./images/css.png";

function SkillImageBanner() {
  return (
    <div className='skill__imageItem'>
      <img
        src={img1}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image1'
      ></img>
      <img
        src={img2}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image2'
      ></img>
      <img
        src={img3}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image3'
      ></img>
      <img
        src={img4}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image4'
      ></img>
      <img
        src={img5}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image5'
      ></img>
      <img
        src={img6}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image6'
      ></img>
      <img
        src={img7}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image7'
      ></img>
      <img
        src={img8}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image8'
      ></img>
      <img
        src={img9}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image9'
      ></img>
      <img
        src={img10}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image10'
      ></img>
      <img
        src={img11}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image11'
      ></img>
      <img
        src={img12}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image12'
      ></img>
      <img
        src={img13}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image12'
      ></img>
      <img
        src={img14}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image14'
      ></img>
      <img
        src={img15}
        style={{
          width: "10%",
          display: "flex",
          alignSelf: "center",
          padding: "10px",
          margin: "10px",
        }}
        alt='image14'
      ></img>
    </div>
  );
}

export default SkillImageBanner;
